import api from './api';
import { TEACHERS_STUDENTS, PARENT_CHILDREN } from '../config/Config';

/**
 * Students a teacher may assign to, or children a parent may assign to (exam prep, etc.).
 * @param {{ teacherMode: boolean, parentMode: boolean }}
 * @returns {Promise<Array<{ id: number, label: string, email?: string }>>}
 */
export async function fetchRelatedStudentsForAssignment({ teacherMode, parentMode }) {
  if (teacherMode) {
    const response = await api.get(TEACHERS_STUDENTS);
    const raw = Array.isArray(response.data)
      ? response.data
      : response.data?.results || response.data?.students || [];
    return raw
      .filter((r) => r.is_accepted === 'accepted' && r.is_active !== false)
      .map((r) => ({
        id: r.student,
        label: (r.student_name || '').trim() || r.student_email || `Student #${r.student}`,
        email: r.student_email || '',
      }));
  }
  if (parentMode) {
    const response = await api.get(PARENT_CHILDREN);
    const list = Array.isArray(response.data) ? response.data : [];
    return list
      .filter((c) => c.status === 'active')
      .map((c) => ({
        id: c.id,
        label:
          [c.first_name, c.last_name].filter(Boolean).join(' ').trim() ||
          c.email ||
          `Child #${c.id}`,
        email: c.email || '',
      }));
  }
  return [];
}
